<template>
  <div class="text-body-2 my-0 py-0">
    <v-row v-if="preprint.url_preprint" align-start justify-start fill-height class="text-body-2 my-0">
        <div  class="d-flex flex-row">
            <a class=" indigo--text text--darken-2 font-weight-bold" :href="preprint.url_preprint" target="_blanc">
                <p class="ml-3 mr-2 text-body-2 my-1">
                    Preprint No. {{preprint.generaltable.registration_number}}
                    <!-- <img  v-if="!mobile" src="../../../../assets/research/acrobat_icon.png" class="pl-1 pb-1">
                    <span v-else class="text-body-2 purple--text text--purple-4 pl-1"> Download PDF</span> -->
                </p>
            </a>
        </div>
        <!-- <div v-if="!mobile" class="d-flex flex-row ml-0 ml-xs-2 mt-2">
            <span class="caption">Institute of Mathematics CAS, {{preprint.year}}</span>
        </div> -->
    </v-row>
    <v-row v-if="mobile"  align-start justify-start row fill-height class="text-body-2 ml-0 my-0">
        <span class="caption">
            <!-- Institute of Mathematics CAS, {{preprint.year}} -->
            Preprint No. {{preprint.generaltable.registration_number}}
        </span>
    </v-row>
    <v-row v-if="preprint.generaltable.display_mode == 2" @click="getPublication(preprint.generaltable.childPublication_id)" :class="['ml-0','mt-0','mb-1','py-0']" >
        <p class="d-flex flex-row caption font-weight-bold mt-1 mb-0"  :class="[{'yellow':!toggleDown}]">
            {{preprint.generaltable.display_text}}
        </p>
        <p  v-if="!mdAndDown"  class="d-flex flex-row mt-1 mb-0"  :class="['px-1',{'yellow':!toggleDown}]">
            <img  v-if="toggleDown"  src="../../../../assets/research/down.png" class="pl-1">
            <img v-else src="../../../../assets/research/up.png" class="pl-1 pb-1">
        </p>
        <p v-else class=" d-flex flex-row font-weight-bold mt-1 mb-0">
            <span  v-if="toggleDown" class="text-body-2 px-1 ">+</span>
            <span v-else class="text-body-2  px-1 yellow ">-</span>
        </p>
    </v-row>
    <v-row v-if="preprint.generaltable.display_mode == 3 || preprint.generaltable.display_mode ==1">
         <p class="d-flex flex-row caption font-weight-bold py-2 pl-3">
            {{preprint.generaltable.display_text}}
        </p>
    </v-row>
    <v-card v-if="!toggleDown" class="mx-1 my-0 py-0 grey lighten-4" min-width = "90%" elevation="2">
      <v-row v-if="!toggleDown" class="mx-1 my-0 py-O grey lighten-4">
          <v-col cols="12"  class="pa-0 ml-0" >
            <app-publication-pattern :publication="publication"></app-publication-pattern>
          </v-col>
          <v-col cols="12"  class="pa-0 mt-1 ml-3">
            <app-authors-title :title="publication.title" :authors="publication.authors" :url="publication.url"></app-authors-title>
            <app-basic-publication :type="publication.type" :year="publication.year"
                :object_type="publication.generaltable">
            </app-basic-publication>
          </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import publicationPattern from '../PublicationPattern.vue';
import basicPublications from '../BasicPublications.vue';
import authorsTitle from '../AuthorsTitle.vue';
import {mapGetters} from 'vuex';
export default {
  props:['preprint','icon'],
  data(){
    return{
      toggleDown:true,
      publication:null,
    }
  },
  components:{
    AppPublicationPattern:publicationPattern,
    AppBasicPublication:basicPublications,
    AppAuthorsTitle:authorsTitle,
  },
  computed: {
    ...mapGetters('header',{
        mdAndDown:'mdAndDown',
        mobile:'mobile',
    })
  },
  methods:{
    getPublication(id) {
      this.toggleDown = !this.toggleDown;
            axios
            .get('/index.php/api/publications/'+id)
            .then(res => {
                const data = res.data;
                this.publication= data[0];
            })
            .catch(error => console.log(error))

    }
  },
}
</script>
